<template>
  <div class="work-item">
    <div v-if="item" class="">
      <div class="work-item-body">
        <h4>{{ item.title }}</h4>
        <p>{{ item.description }}</p>
        <div>
          <div class="row">
            <div
              v-if="!item.discipline.category.disable_timetable"
              class="col-6"
            >
              <selector
                :setLink="`business/teacher_groups/${item.group.id}/journals/${item.discipline.id}/timetables`"
                modal="timetable"
                title="Выберите день "
                v-model="timetable"
                :selectKey="`date`"
                :prefix="`timetable`"
              />
            </div>
            <div class="col-12">
              <star-rating v-model="item.rate"></star-rating>
            </div>
          </div>
          <div class="mt-4">
            <button
              @click="createRating"
              class="btn btn-sm btn-success btn-icon"
            >
              Поставить
            </button>
          </div>
        </div>
        <hr />
        <h5>Начат: {{ item.start_at | dateTimeFormat }}</h5>
        <h5>Завершен: {{ item.done_at | dateTimeFormat }}</h5>
        <h5>Отвечено: {{ decision_count }}/{{ work_count }}</h5>
        <h5>Правильно: {{ true_count }}/{{ test_work_count }}</h5>
        <hr />
        <div class="m-y-6" v-if="item.is_from_catalog" style="max-width: 600px;"> 
          <label class="m-b-1">Выставить баллы</label>
          <div class="flex ai-center">
            <div style="min-width: 200px;">
              <input type="number" name="complexity" class="form-control" v-model="item.points">
            </div>
            <div class="m-x-3">
              <button
                @click="inPoints"
                class="btn btn-sm btn-success btn-icon"
              >
                Выставить баллы
              </button>
            </div>
          </div>
          <div class="m-t-1" v-if="item.recommended_points">
            <label>Рекомендуемый балл: {{ item.recommended_points }}</label>
          </div>
        </div>
        <hr />
        <template v-for="(work, key) in item.data">
          <div class="work" v-if="work.type" :key="key">
            <h4 class="work-title">
              <span class="text-info"> {{ key + 1 }}.</span> {{ work.title }}
              {{ work.type }}
              <span
                v-if="work.decisions && !work.decisions.length"
                class="badge badge-danger"
              >Не ответил</span
              >
            </h4>
            <p class="work-description" v-html="work.description"></p>
            <component
              class="work-content"
              :is="`decision-${work.type}`"
              :work="work"
            />
          </div>
        </template>
        <div>
          <div class="mt-4">
            <button @click="reWork" class="btn btn-sm btn-red btn-icon">Переназначить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import { setRating } from "@/_api/apiPupil";
import { toFormData } from "@/_api/_helper";

export default {
  computed: {
    decision_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        if (this.item.data[i]["decisions"].length) {
          count++;
        }
      }
      return count;
    },
    work_count() {
      return this.item.data.length;
    },

    test_work_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        if (
          this.item.data[i]["type"] === "glue" ||
          this.item.data[i]["type"] === "order" ||
          this.item.data[i]["type"] === "test" ||
          this.item.data[i]["type"] === "dropdown" ||
          this.item.data[i]["type"] === "miss-word" ||
          this.item.data[i]["type"] === "drag-and-drop"
        ) {
          count++;
        }
      }
      return count;
    },
    true_count() {
      let count = 0;
      for (let i = 0; i < this.item.data.length; i++) {
        ///////////////////GLUE
        if (this.item.data[i]["type"] === "glue") {
          let trueCount = 0;

          let answers = this.item.data[i]["answers"];
          let decision = this.item.data[i]["decisions"];
          let answerCount = answers.length;

          for (let d = 0; d < decision.length; d++) {
            let one = decision[d]["answer_id"];
            let two = decision[d]["answer"];
            let groupOne = "01";
            let groupTwo = "02";
            for (let a = 0; a < answerCount; a++) {
              if (answers[a]["id"] == one) {
                groupOne = answers[a]["group_symbol"];
              }
              if (answers[a]["id"] == two) {
                groupTwo = answers[a]["group_symbol"];
              }
            }

            if (groupOne == groupTwo) {
              trueCount++;
            }
          }

          if (trueCount == answerCount / 2 && decision.length > 0) {
            count++;
          }
        }

        ///////////////////TEST
        if (["test", "dropdown"].includes(this.item.data[i]["type"])) {
          let trueAnswer = true;
          let decision = this.item.data[i]["decisions"];
          for (let d = 0; d < decision.length; d++) {
            if (decision[d]["answer_true"] === 0) {
              trueAnswer = false;
            }
          }
          if (trueAnswer === true && decision.length > 0) {
            count++;
          }
        }

        ///////////////////ORDER
        if (this.item.data[i]["type"] === "order") {
          let decision = this.item.data[i]["decisions"];
          let answers = this.item.data[i]["answers"];
          let answerCount = answers.length;
          let trueAnswer = true;

          for (let d = 0; d < decision.length; d++) {
            if (decision[d]["answer"] != d) {
              trueAnswer = false;
            }
          }
          if (trueAnswer === true && decision.length === answers.length) {
            count++;
          }
        }

        ///////////////////MISS-WORD
        if (["miss-word", "drag-and-drop"].includes(this.item.data[i]["type"])) {
          let isCorrect = true;

          let decisions = this.item.data[i]["decisions"]
          let answers = this.item.data[i]["metadata"]["variants"].filter((item) => {
            return item.type === "answer";
          });

          const validated = () => {
            let length = decisions.length === answers.length
            return length && decisions.length > 0 && answers.length > 0
          }

          if (validated) {
            for (let i = 0; i < decisions.length; i++) {
              if (decisions[i].answer !== answers[i].value) {
                isCorrect = false;
                break
              }
            }

            if (isCorrect)
              count++
          }
        }
      }

      return count;
    },
  },
  name: "decision",
  components: {},
  methods: {
    setRating: setRating,
    async reWork(){
      console.log(this.item.client.business.id, 'reWOrk')
      this.$loading(true);
      let url = `${this.$store.state.secApiUrl}/schools/${this.item.client.business.id}/assignments_results/${this.id}/resetProgress`
      // let url = `${this.$store.state.secApiUrl}/schools/${this.item.client.business.id}/assignments_results/`
      await this.$http
        .post(url)
        .then((response) => {
          setTimeout(() => {
            this.$router.push({ query: {} }, ()=>{
              document.getElementById("btn-refresh").click()
            });
          }, 20);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    inPoints() {
      this.$loading(true);
      if(!this.item.points)
        return
      this.$http
        ({
          url: `${this.$store.state.secApiUrl}/schools/${this.item.client.business.id}/assignments_results/${this.item.id}/points`,
          // method: 'method',
          method: 'POST',
          data: toFormData({points: this.item.points}),
          // headers: {
          //   "Content-Type": "multipart/form-data",
          //   "Accept": "application/json",
          //   "api-version": "1",
          //   "platform": "web"
          // }
      })
        .then((response) => {
        // console.log(response);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
    createRating() {
      let params = {
        work: this.item.work,
        value: this.item.rate ? this.item.rate : 0,
        client: this.item.client,
        recommended_points: this.item.recommended_points ? this.item.recommended_points : 0,
        points: 2,
      };

      if (
        this.item.discipline &&
        this.item.discipline.category &&
        !this.item.discipline.category.disable_timetable
      ) {
        params["timetable_id"] = this.timetable ? this.timetable.id : null;
      }

      this.setRating(params, "post");
    },
    async getData() {
      this.$loading(true);
      this.item = await this.$http
        .get(`business/processes/${this.id}`)
        .then((response) => {
          this.timetable = response.data.timetable;
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  async created() {
    this.getData();
  },
  props: {
    id: {
      default: null,
    },
  },
  data() {
    return {
      item: null,
      value: 0,
      rate: null,
      timetable: null,
    };
  },
};
</script>
<style lang="scss">
.work {
  margin-bottom: 20px;
  border-bottom: 1px solid #ebebeb;

  &:last-child {
    border-bottom: none;
  }

  padding: 0 0 15px 0;
}
</style>


